import { render } from "./CompetitorAvailability.vue?vue&type=template&id=15517474"
import script from "./CompetitorAvailability.vue?vue&type=script&lang=js"
export * from "./CompetitorAvailability.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__